import React from 'react';

const Button = ({classnames, handler, children, href}) =>
    <a target="_blank" href={href} onClick={handler}>
        <button className={classnames}>
            {children}
        </button>
    </a>

Button.default = {
    handler: () => {},
    classNames: '',
    href: '#'
}

export default Button;